export const HOME_PAGE = 'home'
export const PLP = 'PLP'
